import { Person } from 'src/app/assabil-kernel/models/entities/master-data/person-entity';

export class UserInfo {

    login               : string;
    password            : string;
    
    person              : Person;
    language            : string;
    kycLevelId          : number;
    token               : string;

    services            : string[];
    menus               : string[];

    institution         : string;

    constructor() {

    }
}

